import React, { useEffect, useState } from "react";
import { Heading } from "../../design/heading";
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from "../../design/table";
import { useTask } from "../../contexts/TaskContext";
import LoadingView from "../../components/LoadingView";
import ErrorView from "../../components/ErrorView";
import TaskListItem from "./components/TaskListItem";
import { Navbar, NavbarItem } from "../../design/navbar";
import EmptyStateView from "../../components/EmptyStateView";
import { useMatter } from "../../contexts/MatterContext";
import NoMatterView from "../../components/NoMatterView";
import TaskButton from "../../components/TaskButton";

const TaskListPage: React.FC = () => {
  const { currentMatterId } = useMatter();
  const { tasks, error, loading } = useTask();
  const [state, setState] = useState<"incomplete" | "completed">("incomplete");

  if (loading.list) {
    return <LoadingView title="Loading Tasks" />;
  }
  if (error.list) {
    return <ErrorView error={error.list} />;
  }

  const filteredTasks = tasks.filter((task) =>
    state === "incomplete" ? !task.isCompleted : task.isCompleted,
  );

  return (
    <>
      <div className="flex items-end justify-between gap-4">
        <Heading>Tasks</Heading>
        <div className="flex gap-4">
          <TaskButton />
        </div>
      </div>
      <Navbar>
        <NavbarItem
          onClick={() => setState("incomplete")}
          current={state === "incomplete"}
        >
          Incomplete
        </NavbarItem>
        <NavbarItem
          onClick={() => setState("completed")}
          current={state === "completed"}
        >
          Completed
        </NavbarItem>
      </Navbar>
      {filteredTasks.length === 0 && (
        <EmptyStateView
          title="No Tasks"
          message="You have not created any tasks yet."
          action={<TaskButton />}
          className="h-full"
        />
      )}
      {filteredTasks.length > 0 && (
        <Table className="mt-8 [--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
          <TableHead>
            <TableRow>
              <TableHeader>Name</TableHeader>
              <TableHeader>Assigned To</TableHeader>
              <TableHeader className="text-right">Completed</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredTasks.map((task) => (
              <TaskListItem key={task._id} task={task} />
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default TaskListPage;
